import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { CalendarDateFormatter, CalendarModule, CalendarNativeDateFormatter, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";

// eslint-disable-next-line @nx/enforce-module-boundaries
import { PipesModule } from "@intocare/pipes";

import {
	CalendarDayDetailComponent,
	CalendarDayDetailEventListComponent,
	CalendarMonthViewComponent,
} from "./components";
import { CalendarWeekViewComponent } from "./components/week-view/week-view.component";
import { CalendarComponent } from "./containers";
import { ButtonModule } from "../button/button.module";
import { UIDirectivesModule } from "../directives";
import { EmptyStateModule } from "../empty-state/empty-state.module";
import { IconModule } from "../icon/icon.module";
import { InputModule } from "../input";
import { LoadingIndicatorModule } from "../loading-indicator/loading-indicator.module";

@NgModule({
	imports: [
		CommonModule,
		CalendarModule.forRoot({
			provide: DateAdapter,
			useFactory: adapterFactory,
		}),
		IconModule,
		InputModule,
		EmptyStateModule,
		UIDirectivesModule,
		ButtonModule,
		LoadingIndicatorModule,
		ReactiveFormsModule.withConfig({ callSetDisabledState: "whenDisabledForLegacyCode" }),
		PipesModule,
		TranslateModule,
	],
	declarations: [
		CalendarComponent,
		CalendarMonthViewComponent,
		CalendarWeekViewComponent,
		CalendarDayDetailComponent,
		CalendarDayDetailEventListComponent,
	],
	exports: [CalendarComponent, CalendarDayDetailComponent],
	providers: [{ provide: CalendarDateFormatter, useClass: CalendarNativeDateFormatter }],
})
export class IcCalendarModule {}
